import { Checkbox } from '@mui/joy';
import { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';

import { Size } from 'theme/enums';

interface IProps {
  value: boolean;
  onChange: (value: boolean) => void;
}

export const MyJobsFilter = ({ value, onChange }: IProps) => {
  const { t } = useTranslation();

  return (
    <Checkbox
      label={t('labelMyJobs')}
      size={Size.MD}
      checked={value}
      onChange={(event: ChangeEvent<HTMLInputElement>) => onChange(event.target.checked)}
      sx={{ paddingRight: 1 }}
    />
  );
};
